import React, { Component } from "react";
import "./Neighbors.css";

class Neighbors extends Component {
	reformatValue(e) {
		let splitVal = e.target.value.replace(/, /, ';');
		this.props.buildSearchQuery("acquirorNeighbor", splitVal);
	}
	render() {
		return (
			<section>
				<p className="panel-section-header">{this.props.queryTypeSingular}'s Neighbors</p>
				<div>
					<small>Separate multiple neighbors (ticker or url) by a semicolon.</small>
					<br />
					<input
						defaultValue={
							this.props.query["acquirorNeighbor"] === undefined
								? ""
								: this.props.query["acquirorNeighbor"]
						}
						onInput={e => this.reformatValue(e)}
						type="text"
						placeholder="e.g. AAPL; amazon.com"
					/>
				</div>
			</section>
		);
	}
}

export default Neighbors;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquirorsOptions/Neighbors/Neighbors.js